module.exports = __webpack_public_path__ + "media/images/front/not-logged-in-lp-renew/img_webinar_06-870e15166314146f1edc2ca6fe91cff1.png";